import http from "@/helper/http";
import {DictPO} from "@/model/system";
import {useMutation} from "@tanstack/react-query";
import {BaseVO} from "@/model/global";

export enum DictEnum {
    AllDict = "/dict/getAllDict",
}

/**
 * 全部字典VO
 */
export interface AllDictVO {
    [key: string]: DictPO[];
}

export const useQueryAllDict = () => useMutation<BaseVO<AllDictVO>>({mutationFn: () => http.post<BaseVO<AllDictVO>>({url: DictEnum.AllDict, data: {codes: [], patentId: ''}})});